if (!customElements.get("m-size-guide")) {
  customElements.define(
    "m-size-guide",
    class MSizeGuide extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          sizeGuideContent: ".m-product-addon--sizeguide",
          openBtn: "[data-open-sizeguide]",
        };
      }

      connectedCallback() {
        console.log('Size guide element connected');
        this.domNodes = queryDomNodes(this.selectors, this);
        const { sizeGuideContent } = this.domNodes;
        if (sizeGuideContent && sizeGuideContent.innerHTML) {
          this.sizeGuideContent = sizeGuideContent.innerHTML;
          this.init();
        } else {
          console.warn('Size guide content not found');
        }
      }

      init() {
        console.log('Initializing size guide');
        if (!this.domNodes.openBtn) {
          console.warn('Size guide button not found');
          return;
        }

        this.domNodes.openBtn.classList.remove("m:hidden");
        this.modal = new MinimogTheme.Modal();
        
        addEventDelegate({
          selector: this.selectors.openBtn,
          handler: (e) => {
            console.log('Size guide button clicked');
            e.preventDefault();
            if (this.sizeGuideContent) {
              const html = document.createElement("DIV");
              html.classList.add('m-size-guide__content');
              html.innerHTML = this.sizeGuideContent;
              this.modal.appendChild(html);
              const colorScheme = html.querySelector('[data-color-scheme]') && html.querySelector('[data-color-scheme]').dataset.colorScheme;
              this.modal.setSizes(`m-size-guide m-gradient ${colorScheme}`);
              this.modal.open();
            } else {
              console.warn('No size guide content available');
            }
          },
        });
      }
    }
  );
} 